module.exports = __webpack_public_path__ + "img/PLANEJAMENTO-COMERCIAL-thumb.65f21320.png";